import React from 'react';
import DateDiff from 'date-diff';

// eslint-disable-next-line import/no-cycle
import { Playouts } from './BadgeButton';
// eslint-disable-next-line import/no-cycle
import ProgressComponent from './ProgressComponent/ProgressComponent';
import { SUBSCRPTION_TYPE } from '../../../PackageInfoScene/getVoyoPackageTexts';

type Parameters = {
    fill?: number;
    showProgress: boolean;
    diff?: number;
    infoDescription?: string;
    progressComponent?: JSX.Element;
    showWarningColor?: boolean;
};

let fill = 0;
let showProgress = false;
let diff;
const now = new Date();
let progressComponent;
let showWarningColor = false;

const getVoyoBadgeParameters = (playouts: Playouts, type?: SUBSCRPTION_TYPE): Parameters => {
    switch (type) {
        case SUBSCRPTION_TYPE.TASTING:
            if (playouts?.playoutsActualCount !== null && playouts.playoutsMaxCount) {
                showProgress = true;
                fill =
                    playouts?.playoutsActualCount !== null && playouts?.playoutsMaxCount !== null
                        ? ((playouts.playoutsMaxCount - playouts?.playoutsActualCount) /
                              playouts.playoutsMaxCount) *
                          100
                        : 0;
                progressComponent = <ProgressComponent playouts={playouts} />;
                if (fill === 0) {
                    showWarningColor = true;
                }
            }
            return {
                showProgress,
                fill,
                progressComponent
            };
        case SUBSCRPTION_TYPE.TRIAL:
            diff =
                Math.floor(new DateDiff(new Date(playouts?.renewalDate as string), now).days()) + 1;
            diff = diff < 0 ? 0 : diff;
            diff = diff > 14 ? 14 : diff;
            fill = (diff / 14) * 100; // we expect 14 days
            if (playouts?.renewalDate === null) {
                fill = 0;
            }
            showProgress = true;
            showWarningColor = false;
            progressComponent = <ProgressComponent playouts={playouts} diff={diff} />;
            if (fill === 0) {
                showWarningColor = true;
            }
            return {
                showProgress,
                fill,
                progressComponent,
                showWarningColor
            };
        case SUBSCRPTION_TYPE.FULL:
            showProgress = true;
            fill = 100;
            progressComponent = <ProgressComponent playouts={playouts} />;
            return {
                showProgress,
                fill,
                progressComponent
            };
        default:
            console.log('No valid subscription.');
            return {
                showProgress
            };
    }
};

export default getVoyoBadgeParameters;
